module.exports = __webpack_public_path__ + "static/img/nps-pt.006c3bb.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/visual-marketing/nps-pt.jpg
// module id = 7NkK
// module chunks = 0